var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavMenu',{attrs:{"app":"","clipped":"","appName":_vm.appName,"menu":_vm.sidebar,"userInfo":_vm.user}})
}
var staticRenderFns = []

export { render, staticRenderFns }